/**
 * Dialog wrapper para edição de Template WhatsApp
 * Redireciona para o EditTemplateWizard com layout de 3 colunas
 */

import { EditTemplateWizard } from './EditTemplateWizard';

interface WhatsAppTemplate {
  id: string;
  inbox_id: string;
  template_id: string;
  name: string;
  language: string;
  category: string;
  status: string;
  rejection_reason: string | null;
  components: any;
  variables: string[] | null;
  example_values: Record<string, string> | null;
  provider_metadata: any;
  created_at: string;
  submitted_at: string | null;
  approved_at: string | null;
  classification_id: string | null;
}

interface EditTemplateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  template: WhatsAppTemplate;
  onSuccess: () => void;
  tenantId?: string;
}

/**
 * Componente wrapper que renderiza o wizard de edição
 * Mantido para compatibilidade com código existente
 */
export function EditTemplateDialog(props: EditTemplateDialogProps) {
  return <EditTemplateWizard {...props} />;
}
